/**
 * Mise en forme du corps d'une nouveauté. Partagée entre le rendu (`NewsBody`)
 * et l'éditeur de l'administration : ce que le rédacteur voit en écrivant est ce
 * que le lecteur verra.
 *
 * En variantes arbitraires Tailwind plutôt qu'en feuille de style : le reset de
 * Tailwind remet titres, listes et liens à nu, et le HTML vient de l'éditeur —
 * on ne peut pas poser de classes sur ses balises.
 */
export const NEWS_BODY_CLASSNAME = [
  'tw-text-sm tw-leading-relaxed tw-text-gray-800 tw-break-words',
  '[&_p]:tw-mb-3 [&_p:last-child]:tw-mb-0',
  '[&_h2]:tw-text-xl [&_h2]:tw-font-bold [&_h2]:tw-text-gray-900 [&_h2]:tw-mt-6 [&_h2]:tw-mb-2',
  '[&_h3]:tw-text-base [&_h3]:tw-font-semibold [&_h3]:tw-text-gray-900 [&_h3]:tw-mt-4 [&_h3]:tw-mb-2',
  '[&>*:first-child]:tw-mt-0',
  '[&_strong]:tw-font-semibold [&_b]:tw-font-semibold [&_em]:tw-italic [&_u]:tw-underline',
  '[&_ul]:tw-list-disc [&_ul]:tw-pl-6 [&_ul]:tw-mb-3 [&_ol]:tw-list-decimal [&_ol]:tw-pl-6 [&_ol]:tw-mb-3',
  '[&_li]:tw-mb-1 [&_li>p]:tw-mb-0',
  '[&_a]:tw-text-affinicar-secondary [&_a]:tw-underline',
  '[&_blockquote]:tw-border-l-4 [&_blockquote]:tw-border-gray-200 [&_blockquote]:tw-pl-4 [&_blockquote]:tw-text-gray-600 [&_blockquote]:tw-my-3',
  '[&_hr]:tw-my-4 [&_hr]:tw-border-gray-200',
  // Image : jamais plus large que le texte, quelle que soit la largeur choisie par
  // le rédacteur (portée par son `style`), et hauteur toujours proportionnelle.
  '[&_img]:tw-block [&_img]:tw-max-w-full [&_img]:tw-h-auto [&_img]:tw-rounded-lg [&_img]:tw-my-4',
  // Vidéo téléversée : mêmes règles que l'image — jamais plus large que le texte,
  // hauteur proportionnelle. Fond noir tant que la première image n'est pas chargée.
  '[&_video]:tw-block [&_video]:tw-max-w-full [&_video]:tw-h-auto [&_video]:tw-rounded-lg [&_video]:tw-my-4 [&_video]:tw-bg-black',
  // Alignement d'un média (`data-media-align`, posé par `SafeHtml`) : par les marges.
  '[&_[data-media-align=center]]:tw-mx-auto [&_[data-media-align=right]]:tw-ml-auto',
  // Vidéo : l'iframe porte des dimensions fixes (640×360) ; on la rend fluide en 16/9.
  '[&_iframe]:tw-block [&_iframe]:tw-w-full [&_iframe]:tw-max-w-2xl [&_iframe]:tw-h-auto [&_iframe]:tw-aspect-video [&_iframe]:tw-rounded-lg [&_iframe]:tw-my-4',
].join(' ');
